import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import Divider from 'material-ui/Divider'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Moment from 'moment'
import { getMonth, getTimezoneDate } from 'utils/date'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import { tenants } from 'selectors/entities'

import InputMoney from 'components/InputMoney'
import PropertyCombobox from './PropertyCombobox'
import BreakDatePicker from './BreakDatePicker'
import BreakDateTill from './BreakDateTill'

import Terms from './Terms'
import Ledger from './Ledger'

let select = dirtyRead(
	(state, props) => ({
		lease: doc(state, props.objectID)
	  , tenants: tenants(state, props)
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		//console.log(props.application);
		let tenantName = props.application && props.application.primaryResident && props.application.primaryResident.additionalInfo
			&& (props.application.primaryResident.firstName + ' ' + props.application.primaryResident.lastName[0]);
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: "hidden"
				   , overflowX: "hidden"
					 , paddingBottom:"10px"
					 , paddingRight:"5px"
				}}
			>
				<div style={{width: "100%", padding:"10px 0px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					<div style={{float:"right", marginTop:"3px"}}>
						{/*<span>
							Lease <span style={{ fontWeight:"bold"}}>${props.lease.rent} </span>
							{Moment(props.lease.dateTill)<=Moment(props.currentDate)?"EXPIRED":Moment(props.lease.dateFrom)>Moment(props.currentDate)?"FROM":props.lease.breakDate?"BREAK":"till"}
							{Moment(props.lease.dateFrom)>Moment(props.currentDate)
								?<span style={{ fontWeight:"bold", marginRight:"10px", color:"green"}}>
									{` ${getTimezoneDate(props.lease.dateFrom).getDate()} ${getMonth(getTimezoneDate(props.lease.dateFrom).getMonth())} ${getTimezoneDate(props.lease.dateFrom).getFullYear()}`}
								</span>
								:props.lease.breakDate?<span style={{ fontWeight:"bold", marginRight:"10px", color:"red"}}>
									{` ${getTimezoneDate(props.lease.breakDateTill).getDate()} ${getMonth(getTimezoneDate(props.lease.breakDateTill).getMonth())} ${getTimezoneDate(props.lease.breakDateTill).getFullYear()}`}
								</span>
								:<span style={{ fontWeight:"bold", marginRight:"10px", color:"black"}}>
									{` ${getTimezoneDate(props.lease.dateTill).getDate()} ${getMonth(getTimezoneDate(props.lease.dateTill).getMonth())} ${getTimezoneDate(props.lease.dateTill).getFullYear()}`}
								</span>
							}
						</span>*/}
					</div>
					<div style={{paddingLeft:"20px"}}>
						<PropertyCombobox objectID={props.objectID}/>
						{props.application ? <Link
							to={`/landlord/application/${props.application._id}`}
							style={{
								color: 'inherit'
							}}
						>
						<img style={{width:"20px"}} src="/landlord/static/img/svg-icon/tenants_green.svg" className="left-navigation-icons"/>
						<span style={{marginLeft:"22px"}}>{tenantName}</span>
						</Link>
						:props.lease.tenantID?
						<div>
							<img style={{width:"20px"}} src="/landlord/static/img/svg-icon/tenants_green.svg" className="left-navigation-icons"/>
							<span style={{marginLeft:"22px"}}>{props.tenants[props.lease.tenantID].tenant || props.tenants[props.lease.tenantID].firstName}</span>
						</div>
						:<div>
							<img style={{width:"20px"}} src="/landlord/static/img/svg-icon/tenants_green.svg" className="left-navigation-icons"/>
							<span style={{marginLeft:"22px"}}>no data</span>
						</div>}
					</div>
					{props.lease.breakDate && <div style={{width: "100%", paddingLeft:"20px", paddingTop:"10px"}}>
						<BreakDatePicker objectID={props.objectID} />
						<BreakDateTill objectID={props.objectID} />
					</div>}
				</div>
				<Terms objectID={props.objectID} />
				<Ledger leaseID={props.objectID} width={props.width}/>
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/landlord/leaseForm/LeftSide.js